import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { ListLikeToneRequest } from '../api/listlikedtone/listliketonerequest';
import { ListLikeToneResponse, ListLikeToneResponseDtoImpl } from '../api/listlikedtone/listliketoneresponse';
import { ListLikeToneBuilder } from '../dto/listliketone/listliketonebuilder';
import { ListLikeToneDtoImpl } from '../dto/listliketone/listliketonedto';
import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { SixdeeCRBTAPIProcessor } from './sixdeecrbtapiprocessor';
import { Strings } from '../../utils/resources/strings';

export class ListLikeToneAPIProcessorImpl extends SixdeeCRBTAPIProcessor<ListLikeToneRequest, ListLikeToneResponse>
{
    execute(request: ListLikeToneRequest): void 
    {
        super.execute(request);
    }

    onSuccess(responseMapper: ResponseMapper): void 
    {
        super.onSuccess(responseMapper);
        try {

            if (+responseMapper.getStatusCode() === StatusCodes.SUCCESS) {

                let response = new ListLikeToneResponseDtoImpl(APIFeatures.LIST_LIKE_TONE, "List Like Tone Success");

                let listLikeToneDto = new ListLikeToneDtoImpl();
                listLikeToneDto.setLikedToneList(new ListLikeToneBuilder(responseMapper.getResponseMap()).buildAll());
                response.setListLikeToneDto(listLikeToneDto);

                this.getAPISuccess(response);
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.NO_CONTENT)
            {
                this.getAPISuccess(new ListLikeToneResponseDtoImpl(APIFeatures.LIST_LIKE_TONE, this.getContext().getResources().getString(Strings.no_data_list_available)));
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.INTERNAL_SERVER_ERROR)
            {
                this.getAPIFailure(new ListLikeToneResponseDtoImpl(APIFeatures.LIST_LIKE_TONE, this.getContext().getResources().getString(Strings.internal_server_error)));
            }
        }
        catch (e) {
            this.getAPIFailure(new ListLikeToneResponseDtoImpl(APIFeatures.LIST_LIKE_TONE, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
        super.onFailure(responseMapper);
    
            this.getAPIFailure(new ListLikeToneResponseDtoImpl(APIFeatures.LIST_LIKE_TONE, responseMapper.getStatusMsg()));
        
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/listliketoneapiprocessor.tsx